// src/backend/api.js
import Cookies from 'js-cookie';

const API_URL = 'https://api.huberway.com';

const MAIL_API_URL = 'https://campaign.huberway.com';
const MAIL_API_TOKEN = 'b499ab5de4196d8d4e9df6acafd4f61eab2cb98399e3da0e74b5bd22a76a';
const LIST_UID = "67b46fc911b40";

// Funzione per ottenere i dettagli dell'account
export const getAccountDetails = async () => {
    const authToken = Cookies.get('auth_token');
    // const authToken = '774766dc33eb73f3abcbb0b19a4f46f4';

    if (!authToken) {
        throw new Error('No auth token found');
    }

    const response = await fetch(`${API_URL}/AuthController/accountDetails`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ auth_token: authToken }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch account details');
    }

    return await response.json();
};

// Funzione per ottenere i dettagli del sito web
export const getWebsiteDetails = async (website_id) => {
    const authToken = Cookies.get('auth_token');

    // const authToken = '774766dc33eb73f3abcbb0b19a4f46f4';

    if (!authToken) {
        throw new Error('No auth token found');
    }

    const response = await fetch(`${API_URL}/WebsiteController/website`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ auth_token: authToken, website_id }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch website details');
    }

    return await response.json();
};

export const subscribeNewsletter = async (address,name,shop,phone,nominativo,luogo) => {
    await fetch(`${MAIL_API_URL}/api/v1/subscribers`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            api_token: MAIL_API_TOKEN,
            list_uid: LIST_UID,
            EMAIL: address,
            NAME: name,
            SHOP: shop,
            PHONE: phone,
            NOMINATIVO: nominativo,
            LUOGO: luogo
        }),
    })
}
